<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="任务编码:">
                <el-input size="small" v-model="dataForm.taskCode" class="input-width" placeholder="任务编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="技术通知:">
                <el-input size="small" v-model="dataForm.taskName" class="input-width" placeholder="技术通知" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="项目工程师:">
                <el-input size="small" v-model="dataForm.projectManagerName" class="input-width" placeholder="项目工程师" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="项目名称:">
                <el-input size="small" v-model="dataForm.projectName" class="input-width" placeholder="项目名称" clearable @blur="getDataList"></el-input>
            </el-form-item><br>
            <el-form-item label="项目编码:">
                <el-input size="small" v-model="dataForm.projectCode" class="input-width" placeholder="项目编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="车型:" label-width="71px">
                <el-input size="small" v-model="dataForm.carType" class="input-width" placeholder="车型" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="状态:" label-width="85px">
                <!-- <el-select size="small" v-model="dataForm.taskStatus" placeholder="请选择状态" clearable @change="getDataList" class="input-width">
                    <el-option v-for="item in TASK_STATUS_VALUE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select> -->
                <el-cascader class="input-width" v-model="taskStatuses" :options="TASK_STATUS_VALUE" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sourcing:distributeTask:newbutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建任务
                </el-button> -->
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    导入订单
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" style="width: 100%;" :default-expand-all="false" border :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="taskStatus" header-align="center" align="center" label="状态" width="120">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.taskStatus)">
                            {{taskStatusFormat(scope.row.taskStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="taskCode" header-align="center" align="left" label="任务编码" width="220">
                </el-table-column>
                <el-table-column prop="taskName" header-align="center" align="left" label="技术通知" width="220">
                </el-table-column>

                <el-table-column prop="technicalCode" header-align="center" align="left" label="技术通知编码" width="220">
                </el-table-column>
                <el-table-column prop="remark" header-align="center" align="left" label="技术通知描述" width="220">
                </el-table-column>

                <el-table-column prop="projectManagerName" header-align="center" align="left" label="项目工程师" width="170">
                </el-table-column>
                <!-- <el-table-column prop="projectName" header-align="center" align="left" label="项目名称" width="220">
                </el-table-column>
                <el-table-column prop="projectCode" header-align="center" align="left" label="项目编码" width="220">
                </el-table-column> -->
                <el-table-column prop="supplyEngineer" header-align="center" align="left" label="采购工程师" width="170">
                </el-table-column>
                <el-table-column prop="carType" header-align="center" align="left" label="车型" width="170">
                </el-table-column>
                <el-table-column prop="rfqCode" header-align="center" align="left" label="RFQ编码" width="170">
                </el-table-column>
                <el-table-column prop="rfqStatus" header-align="center" align="center" label="询价单状态" width="100">
                    <template slot-scope="scope">
                        <span :class="getRfqStatusClass(scope.row.rfqStatus)">
                            {{rfqStatusFormat(scope.row.rfqStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="taskAllocationTime" header-align="center" align="right" label="任务分配时间" :formatter="dateFormat" width="170">
                </el-table-column>
                <el-table-column prop="createTaskTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="170">
                </el-table-column>
                <el-table-column header-align="center" align="center" label="操作" width="190" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" align="center" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" align="center" :disabled="scope.row.taskStatus !== '8' ? false : true" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            分配
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" :disabled="judgeTaskStatus2(scope.row.taskStatus)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    purchaseTaskList,
    deletePurchaseTask
} from '@/controller/purchaseTask'
import moment from 'moment'
import {
    getLabelByValue,
    TASK_STATUS_VALUE,
    RFQ_STATUS_VALUE
} from "@/utils/const";
import AddOrUpdate from './task-add-or-update'
// require('@/mock/mockTask');
// require('@/mock/mockTech');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                // id:'',
                taskCode: '',
                taskName: '',
                projectCode: '',
                projectName: '',
                projectManagerName: '',
                taskStatuses: [],
                carType: '',
                createTaskTime: '',
            },
            taskStatuses: [
                ['0'],
                ['5']
            ],
            getLabelByValue: getLabelByValue,
            TASK_STATUS_VALUE: TASK_STATUS_VALUE,
            RFQ_STATUS_VALUE: RFQ_STATUS_VALUE,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            addOrUpdatePurchaseVisible: false

        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 270
            }
        }
    },
    components: {
        AddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        //判断分配任务状态
        // judgeTaskStatus1(val) {
        //     if (val === '6' || val === '5') {
        //         this.isActive = true
        //         return false
        //     } else {
        //         this.isActive = false
        //         return true
        //     }
        // },
        judgeTaskStatus2(val) {
            if (val === '6' || val === '5') {
                this.isActive = true
                return false
            } else {
                this.isActive = false
                return true
            }
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        taskStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(TASK_STATUS_VALUE, value)
        },
        rfqStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(RFQ_STATUS_VALUE, value)
        },
        // 新增或编辑子节点
        addChildHandle(id, parentId, parentName, parentNodePath) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
            })
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.dataForm.taskStatuses = []
            this.taskStatuses.forEach(status => {
                this.dataForm.taskStatuses.push(status[0])
            })
            purchaseTaskList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                ...this.dataForm
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, "edit")
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePurchaseTask({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                case '5':
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        },
        getRfqStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                case '6b':
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        }
    }
}
</script>

<style lang="scss" scoped>
.input-width {
    width: 155px;
}
</style>
